import {
  put, all, call, select, takeEvery, takeLatest, fork, cancel,
} from 'redux-saga/effects';

import { delay } from 'redux-saga';
import { startSubmit, stopSubmit } from 'circe/forms/actions';
import { show as showNotification } from 'circe/notifications/actions';
import { getCurrentAuthHeader } from 'domain/fuse/auth/utils';
import { exception } from 'circe/logger';
import * as I18n from 'circe/I18n';
import { generatePath } from 'react-router-dom';
import { ROUTES as ORDER_ROUTES } from 'domain/shipment/order/constants';

import mineSaga from 'domain/shipment/mine/saga';
import bookSaga from 'domain/shipment/book/saga';
import trackingSaga from 'domain/shipment/tracking/saga';
import pdfSaga from 'domain/shipment/pdf/saga';
import bulkSaga from 'domain/shipment/bulk/saga';
import reportSaga from 'domain/shipment/report/saga';
import newOrderSaga from 'domain/shipment/newOrder/saga';
import batchOrdersSaga from 'domain/shipment/batchOrders/saga';
import { FORM_NAME } from 'domain/batch/fuse/Forms/UploadSheet/constants';
import { failed } from 'domain/shipment/newOrder/actions';
import { downloadReport } from 'domain/shipment/api';
import assignSaga from 'domain/shipment/assign/saga';
import orderSaga from 'domain/shipment/order/saga';
import viewSaga from 'domain/shipment/view/saga';
import * as api from 'domain/shipment/api';
import { ASSIGN_ORDERS_FORM_NAME, ROUTES } from 'domain/shipment/constants';
import {
  fetch,
  fetched,
  requestAddressUpdate,
  fetchedSalesOrders,
  batchSalesOrders,
  batchedSalesOrders,
  toggleBatchingScreen,
  generatedReport,
  generateReport,
  batchedSuccessfully,
} from 'domain/shipment/actions';
import uploadSage from 'domain/shipment/factoryUpload/saga';

function* doFetch() {
  try {
    const state = yield select();

    const headers = yield call(getCurrentAuthHeader, state);

    let allShipments = [];

    let resp = yield call(api.fetch, null, headers);

    if (!resp) {
      throw new Error('Fetch Shipments failed to load');
    }

    yield put(fetched(resp.results));

    allShipments = allShipments.concat(resp.results);

    while (resp.nextPage && resp.nextPage.hasResults) {
      try {
        yield delay(2000);

        resp = yield call(api.fetch, resp.nextPage.cursor, headers);

        if (!resp) {
          throw new Error('Fetch Shipments failed to load');
        }
        allShipments = allShipments.concat(resp.results);

        yield put(fetched(allShipments));
      } catch (e) {
        exception(e);
      }
    }
  } catch (e) {
    exception(e);
  }
}

function* doRequestUpdateAddress(action) {
  try {
    const {
      payload: { waybill, phone },
    } = action;
    const state = yield select();
    const headers = yield call(getCurrentAuthHeader, state);
    const response = yield call(
      api.requestUpdateAddress,
      SYSTEM_DOMAIN,
      {
        waybillId: waybill,
        shipperName: 'ClassicDeals',
        handler: phone,
        locale: 'AR_SA',
        type: 'SMS',
      },
      headers,
    );
  } catch (e) {
    exception(e);
  }
}

function* doBatchSalesOrders(context, action) {
  const { payload } = action;

  const { values } = payload;

  const { salesOrders, batchRequestType, selectedFleet } = values;
  let resp;
  try {
    yield put(startSubmit(ASSIGN_ORDERS_FORM_NAME));

    const state = yield select();

    const headers = yield call(getCurrentAuthHeader, state);

    const formData = new FormData();

    formData.append('file', salesOrders[0]);
    formData.append('batchRequestType', batchRequestType);
    formData.append('fleetId', selectedFleet ? selectedFleet.account : null);

    resp = yield call(api.batchSalesOrders, formData, headers);
    yield put(batchedSalesOrders(resp));
    if (!resp.success) {
      throw new Error('Unable to batch sales orders.');
    }

    yield put(toggleBatchingScreen());
    yield put(batchedSuccessfully());
    yield put(
      showNotification(
        I18n.str('salesOrdersBatchedSuccessfully', 'Sales orders were batched successfully.'),
        'success',
      ),
    );
  } catch (error) {
    yield put(batchedSalesOrders(resp));
    yield put(stopSubmit(ASSIGN_ORDERS_FORM_NAME));
    yield put(toggleBatchingScreen());
    yield put(batchedSuccessfully());
    if (resp && !resp.response) {
      yield put(
        showNotification(
          I18n.str('uploadBatchSalesOrders', 'Unable to batch sales orders.'),
          'error',
        ),
      );
    } else if (resp && resp.response) {
      yield put(
        showNotification(
          I18n.str('salesOrdersBatchedSuccessfully', 'Sales orders were batched successfully.'),
          'success',
        ),
      );
    } else {
      yield put(
        showNotification(
          I18n.str('uploadBatchSalesOrders', 'Unable to batch sales orders.'),
          'error',
        ),
      );
    }
    exception(error);
  }
}

function* doDownload(action) {
  const { payload } = action;
  const { values } = payload;

  try {
    const state = yield select();

    const headers = yield call(getCurrentAuthHeader, state);

    const resp = yield call(api.downloadReport, values, headers);

    if (!resp) {
      throw new Error('Unable to download the sales orders report');
    }
    yield window.open(resp);
    yield put(generatedReport());
  } catch (e) {
    exception(e);
    yield put(generatedReport());
    yield put(
      showNotification(
        I18n.str('unableToDownloadTheReport', 'Unable to download the report'),
        'error',
      ),
    );
  }
}
export default function* (context) {
  yield all([
    takeLatest(fetch().type, doFetch),
    takeLatest(batchSalesOrders().type, doBatchSalesOrders, context),
    takeLatest(generateReport().type, doDownload),
    takeEvery(requestAddressUpdate().type, doRequestUpdateAddress),
    mineSaga(),
    viewSaga(),
    bookSaga(),
    trackingSaga(),
    pdfSaga(),
    orderSaga(),
    bulkSaga(),
    assignSaga(),
    reportSaga(),
    newOrderSaga(context),
    batchOrdersSaga(context),
    uploadSage(context),
  ]);
}
